/**
 * Stable CSS class names for E2E — Schedule detail card / functions section.
 */
export const SDF = {
    root: 'schedule-detail-card-functions',
    actionsRow: 'schedule-detail-card-functions__actions-row',
    actionButton: 'schedule-detail-card-functions-input--button-action',
    actionButtonStart: 'schedule-detail-card-functions-input--button-start-service',
    actionButtonStop: 'schedule-detail-card-functions-input--button-stop-service',
    actionButtonRun: 'schedule-detail-card-functions-input--button-run-service',
    actionIcon: 'schedule-detail-card-functions__action-icon',

    editButton: 'schedule-detail-card-functions-input--button-edit',
} as const;

export const sdfCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

